export const CONFLICT = 'CONFLICT'
export const ERROR = 'ERROR'
export const INGESTING = 'INGESTING'
export const COMPLETE = 'COMPLETE'
export const STAND_BY = 'STAND_BY'
export const OVERRIDDEN = 'OVERRIDDEN'
